export const REVIEWS_LIMIT = 6;
export const FAQ_LIMIT = 4;
export const SIMILAR_RENTALS_LIMIT = 4;
export const ROUTE_PARAMS = ['location', 'slug'];
